import { useState } from 'react'

import { Box, Button, Loading } from '@factorialco/deprecated-design-system'
import { AssessmentsQueryDocument } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import AssessmentsTable from 'modules/competencies/pages/performance/AssessmentsPage/AssessmentsTable'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'

import { AssessmentsProvider } from '../assessmentsContext'
import { CompetenciesProvider } from '../competenciesContext'

const Assessments = () => {
  const [showExportSidepanel, setShowExportSidepanel] = useState(false)
  const { data, loading } = useQuery(AssessmentsQueryDocument)

  if (loading) return <Loading />

  const canManageCompetencies = data?.competencies._policies.competenciesManage.can ?? false

  return (
    <ResponsivePage.Body>
      <CompetenciesProvider>
        <AssessmentsProvider>
          <Box gap="s16">
            <Callout
              type="warning"
              description={i18n.t('competencies_v3.deprecation_callout.description')}
              title={i18n.t('competencies_v3.deprecation_callout.title')}
              action={
                <Button type="secondary" onClick={() => setShowExportSidepanel(true)}>
                  {i18n.t('common.export')}
                </Button>
              }
            />

            {showExportSidepanel && (
              <ExportSidepanel
                resource="competencies.assessment_groups_export"
                onClose={() => setShowExportSidepanel(false)}
              />
            )}
            <AssessmentsTable canManageCompetencies={canManageCompetencies} />
          </Box>
        </AssessmentsProvider>
      </CompetenciesProvider>
    </ResponsivePage.Body>
  )
}

export default Assessments
